// features/admin/admin-routes.ts
import { APP_ROUTES } from '../../../app-routes';

export const ADMIN_ROUTES = {
  Users: '',
  Roles: 'roles',
  Branches: 'branches',
  AuditLog: 'audit-log',
  Storefront: 'storefront',
  Subscription: 'subscription',
  Settings: 'settings'
};

export const AdminPaths = {
  Users: `/${APP_ROUTES.Users}`,
  Roles: `/${APP_ROUTES.Roles}`,
  Branches: `/${APP_ROUTES.Branches}`,
  AuditLog: `/${APP_ROUTES.AuditLog}`,
  Storefront: `/${APP_ROUTES.Storefront}`,
  Subscription: `/${APP_ROUTES.Subscription}`,
  Settings: `/${APP_ROUTES.Settings}`
};
